export default __webpack_public_path__ + "static/media/hands_clap.05390cc8.png";